import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

export const UnavailabilityReasonSubtitleContainer = styled.h3`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  margin-block-end: ${primitive.$spacing3};
  font: var(--font-headerTwo);
`;

export const UnavailabilityReasonIconContainer = styled.span`
  margin-inline-start: ${primitive.$spacing1};
`;

export const ContentText = styled.p`
  color: ${Styles.color.black};
  text-align: center;
  margin: 0;

  &:not(:last-of-type) {
    margin-block-end: ${primitive.$spacing6};
  }
`;
